<div style="text-align: center; padding: 50px; font-family: Arial, sans-serif; margin-top: 15%;">
    <h1 *ngIf="ottStatus === 'missing'" style="color: #e9882d;">OTT Missing</h1>
    <h1 *ngIf="ottStatus === 'expired'" style="color: #e9882d;">OTT Expired</h1>
    <p *ngIf="ottStatus === 'missing'">OTT is missing from your payload.</p>
    <p *ngIf="ottStatus === 'expired'">Your OTT has been expired.</p>
</div>
